<template>
  <div v-if="isLoggedIn" class="mobile-menu-nav" :class="{ auth: isAuth }">
    <div class="mobile-menu-nav__nav-wrp">
      <div class="mobile-menu-nav__nav-avatar" @click="$emit('open-details')">
        <img src="../../../../public/logo-mobile.png" alt="LOGO_MOBILE" />
      </div>

      <router-link
        class="mobile-menu-nav__nav-btn"
        :to="vueRoutes.marketplace"
        active-class="nav-btn-icon-active"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 25 25"
          class="mobile-menu-nav__nav-btn-icon"
        >
          <!--eslint-disabled-next-line-->
          <path
            d="M0.302822 8.9074C0.0783872 8.4911 -0.0255903 8.02048 0.00255892 7.54837C0.0307082 7.07626 0.18987 6.62133 0.462183 6.23465C0.907202 5.58169 1.50317 5.04573 2.19952 4.67225L10.0123 0.605842C10.7803 0.206524 11.633 -0.00195313 12.4986 -0.00195312C13.3641 -0.00195313 14.2169 0.206524 14.9848 0.605842L22.7966 4.67538C23.4929 5.04885 24.0889 5.58481 24.5339 6.23778C24.8062 6.62446 24.9654 7.07938 24.9935 7.5515C25.0217 8.02361 24.9177 8.49422 24.6933 8.91052C24.4516 9.36761 24.0892 9.74964 23.6455 10.015C23.2018 10.2804 22.6938 10.419 22.1768 10.4156H2.8203C2.3028 10.4189 1.79436 10.2799 1.35042 10.014C0.906487 9.748 0.544111 9.36522 0.302822 8.9074ZM23.9558 22.9148C23.9558 22.3623 23.7364 21.8325 23.3457 21.4418C22.955 21.0511 22.4252 20.8316 21.8727 20.8316V12.4988H19.7896V20.8316H16.6648V12.4988H14.5817V20.8316H10.4154V12.4988H8.33229V20.8316H5.20758V12.4988H3.12444V20.8316C2.57195 20.8316 2.0421 21.0511 1.65143 21.4418C1.26077 21.8325 1.0413 22.3623 1.0413 22.9148C0.765054 22.9148 0.500127 23.0246 0.304794 23.2199C0.109462 23.4153 -0.000274595 23.6802 -0.000274595 23.9564C-0.000274595 24.2327 0.109462 24.4976 0.304794 24.693C0.500127 24.8883 0.765054 24.998 1.0413 24.998H23.9558C24.2321 24.998 24.497 24.8883 24.6923 24.693C24.8877 24.4976 24.9974 24.2327 24.9974 23.9564C24.9974 23.6802 24.8877 23.4153 24.6923 23.2199C24.497 23.0246 24.2321 22.9148 23.9558 22.9148Z"
          />
        </svg>
      </router-link>

      <router-link
        class="mobile-menu-nav__nav-btn"
        :to="vueRoutes.realEstate"
        active-class="nav-btn-icon-active"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 25 25"
          class="mobile-menu-nav__nav-btn-icon"
        >
          <!--eslint-disabled-next-line-->
          <path
            d="M11.4583 0H3.125C2.2962 0 1.50134 0.32924 0.915291 0.915291C0.32924 1.50134 0 2.2962 0 3.125L0 25H14.5833V3.125C14.5833 2.2962 14.2541 1.50134 13.668 0.915291C13.082 0.32924 12.2871 0 11.4583 0V0ZM6.25 19.7917H3.125V17.7083H6.25V19.7917ZM6.25 15.625H3.125V13.5417H6.25V15.625ZM6.25 11.4583H3.125V9.375H6.25V11.4583ZM6.25 7.29167H3.125V5.20833H6.25V7.29167ZM11.4583 19.7917H8.33333V17.7083H11.4583V19.7917ZM11.4583 15.625H8.33333V13.5417H11.4583V15.625ZM11.4583 11.4583H8.33333V9.375H11.4583V11.4583ZM11.4583 7.29167H8.33333V5.20833H11.4583V7.29167ZM21.875 5.20833H16.6667V25H25V8.33333C25 7.50453 24.6708 6.70968 24.0847 6.12362C23.4987 5.53757 22.7038 5.20833 21.875 5.20833ZM21.875 19.7917H19.7917V17.7083H21.875V19.7917ZM21.875 15.625H19.7917V13.5417H21.875V15.625ZM21.875 11.4583H19.7917V9.375H21.875V11.4583Z"
          />
        </svg>
      </router-link>

      <router-link
        class="mobile-menu-nav__nav-btn"
        active-class="nav-btn-icon-active"
        :to="vueRoutes.currency"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 28 25"
          class="mobile-menu-nav__nav-btn-icon"
        >
          <!--eslint-disabled-next-line-->
          <path
            d="M21.9707 0.822368L9.43374 0C4.22363 0 0 5.59644 0 12.5C0 19.4036 4.22363 25 9.43374 25L21.7224 24.6711C22.7027 24.6711 23.2709 23.6644 23.3361 22.3684C23.4077 20.9445 23.1677 20.0658 22.0907 20.0658H19.0146C16.3968 20.0658 14.2747 17.2539 14.2747 13.7854V11.2146C14.2747 7.74608 16.3968 4.93421 19.0146 4.93421H22.0907C23.1677 4.93421 23.7801 4.22002 23.7085 2.79605C23.6433 1.50009 22.9509 0.822368 21.9707 0.822368Z"
          />
          <!--eslint-disabled-next-line-->
          <path
            d="M21.3613 0H2.73082C1.22263 0 0 1.62002 0 3.61842V21.3816C0 23.38 1.22263 25 2.73082 25H21.3613C22.7642 25 23.9472 23.5913 24.0508 21.7374C24.1021 20.8193 24.1294 20.0658 24.0809 20.0658H17.0043C15.4961 20.0658 14.2747 18.4453 14.2747 16.4469V8.55308C14.2747 6.55468 15.4961 4.93421 17.0043 4.93421H24.0809C24.1294 4.93421 24.1021 4.18069 24.0508 3.26257C23.9472 1.40867 22.7642 0 21.3613 0Z"
          />
          <!--eslint-disabled-next-line-->
          <path
            d="M16.625 11.2069C16.625 8.82636 18.5837 6.89655 21 6.89655H23.625C26.0412 6.89655 27.9999 8.82636 27.9999 11.2069V13.7931C27.9999 16.1736 26.0412 18.1034 23.625 18.1034H21C18.5837 18.1034 16.625 16.1736 16.625 13.7931V11.2069Z"
          />
          <!--eslint-disabled-next-line-->
          <path
            d="M19.6583 8.62069C19.6583 7.66847 20.4418 6.89655 21.4083 6.89655H26.25C27.2165 6.89655 28 7.66847 28 8.62069V16.3793C28 17.3315 27.2165 18.1034 26.25 18.1034H21.4083C20.4419 18.1034 19.6583 17.3315 19.6583 16.3793V8.62069Z"
          />
          <!--eslint-disabled-next-line-->
          <path
            d="M21.9333 12.5001C21.9333 13.5316 21.0845 14.3679 20.0375 14.3679C18.9904 14.3679 18.1417 13.5316 18.1417 12.5001C18.1417 11.4685 18.9904 10.6322 20.0375 10.6322C21.0845 10.6322 21.9333 11.4685 21.9333 12.5001Z"
          />
          <!--eslint-disabled-next-line-->
          <path
            d="M22.7498 12.5001C22.7498 13.6904 21.7704 14.6553 20.5623 14.6553C19.3542 14.6553 18.3748 13.6904 18.3748 12.5001C18.3748 11.3099 19.3542 10.345 20.5623 10.345C21.7704 10.345 22.7498 11.3099 22.7498 12.5001Z"
            fill="#333333"
          />
        </svg>
      </router-link>

      <router-link
        class="mobile-menu-nav__nav-btn"
        :to="vueRoutes.profile"
        active-class="nav-btn-icon-active"
      >
        <svg
          viewBox="0 0 25 25"
          xmlns="http://www.w3.org/2000/svg"
          class="mobile-menu-nav__nav-btn-icon"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.1 25H13.8C14.3 25 14.7 24.6016 14.7 24.1036V23.008C14.7 22.51 15 22.0119 15.6 21.8127C16 21.7131 16.4 21.5139 16.8 21.3147C17.3 21.1155 17.8 21.2151 18.2 21.5139L19 22.3107C19.4 22.7092 20 22.7092 20.3 22.3107L22.2 20.4183C22.6 20.0199 22.6 19.4223 22.2 19.1235L21.4 18.3267C21 17.9283 20.9 17.4303 21.2 16.9323C21.4 16.5339 21.6 16.1354 21.7 15.737C21.9 15.239 22.4 14.8406 22.9 14.8406H24.1C24.6 14.8406 25 14.4422 25 13.9442V11.255C25 10.757 24.6 10.3586 24.1 10.3586H22.9C22.4 10.3586 21.9 10.0598 21.7 9.46215C21.6 9.06374 21.4 8.66532 21.2 8.26692C21 7.76891 21.1 7.27091 21.4 6.8725L22.3 5.97609C22.5 5.77689 22.6 5.57768 22.6 5.27887C22.6 4.98007 22.5 4.78088 22.3 4.58168L20.4 2.68922C20 2.29082 19.4 2.29082 19.1 2.68922L18.2 3.58566C17.8 3.98407 17.3 4.08365 16.8 3.78485C16.4 3.58564 16 3.48604 15.6 3.28684C15.1 3.08764 14.8 2.68925 14.8 2.09164V0.896408C14.8 0.3984 14.4 0 13.9 0H11.1C10.6 0 10.2 0.3984 10.2 0.896408V2.09164C10.2 2.58965 9.89999 3.08764 9.39999 3.28684C8.99999 3.38644 8.60001 3.58564 8.20001 3.78485C7.70001 3.98405 7.20002 3.88447 6.80002 3.58566L5.89999 2.68922C5.59999 2.29082 4.90001 2.29082 4.60001 2.68922L2.70001 4.58168C2.50001 4.78088 2.39999 4.98007 2.39999 5.27887C2.39999 5.57768 2.50001 5.77689 2.70001 5.97609L3.60001 6.8725C4.00001 7.27091 4.10002 7.76891 3.80002 8.26692C3.60002 8.66532 3.40002 9.06374 3.30002 9.46215C3.10002 9.96016 2.60001 10.3586 2.10001 10.3586H0.899994C0.399994 10.3586 0 10.757 0 11.255V13.9442C0 14.4422 0.399994 14.8406 0.899994 14.8406H2.10001C2.60001 14.8406 3.10002 15.1394 3.30002 15.737C3.40002 16.1354 3.60002 16.5339 3.80002 16.9323C4.00002 17.4303 3.90001 17.9283 3.60001 18.3267L2.80002 19.1235C2.40002 19.5219 2.40002 20.1195 2.80002 20.4183L4.70001 22.3107C5.00001 22.7092 5.7 22.7092 6 22.3107L6.80002 21.5139C7.20002 21.1155 7.70001 21.0159 8.20001 21.3147C8.60001 21.5139 8.99999 21.7131 9.39999 21.8127C9.89999 22.0119 10.3 22.51 10.3 23.008V24.1036C10.2 24.6016 10.6 25 11.1 25ZM5.5 12.5498C5.5 16.3347 8.6 19.5219 12.5 19.5219C16.3 19.5219 19.5 16.4343 19.5 12.5498C19.5 8.76494 16.4 5.57769 12.5 5.57769C8.6 5.6773 5.5 8.76494 5.5 12.5498Z"
          />
        </svg>
      </router-link>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import router from '@/router';
import { useStore } from 'vuex';
import { vueRoutes } from "@/router/router-const";

export default {
  emits: ['open-details'],

  setup() {
    const store = useStore();
    let isAuth = computed(() =>
      // router.currentRoute.value.fullPath.includes('/authorization/')
      router.currentRoute.value.fullPath.includes(vueRoutes.authorization.name)
    );
    const isLoggedIn = computed(() => store.getters['auth/isLoggedIn']);
    return { isAuth, isLoggedIn, vueRoutes };
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/variables';
@import '@/scss/mixins';

.mobile-menu-nav {
  display: none;
  width: 100%;
  bottom: 1rem;
  position: fixed;
  z-index: 10;

  &.auth {
    display: none;
  }

  @include respond-to($sidebar-hide-bp) {
    display: flex;
  }

  &__nav-wrp {
    display: flex;
    justify-content: space-around;
    background-color: $mobile-menu-bg;
    border-radius: 3rem;
    align-items: center;
    width: 30rem;
    height: 6rem;
    padding: 0 0.5rem;
    margin: auto;
  }

  &__nav-btn,
  &__nav-avatar {
    display: flex;
    align-items: center;
  }

  &__nav-avatar img {
    width: 4rem;
    height: 4rem;
    object-fit: contain;
  }

  &__nav-btn-icon {
    fill: $mobile-menu-icons;
    width: 2.5rem;
    height: 2.5rem;
  }
}

.nav-btn-icon-active svg {
  fill: $mobile-menu-active-icons;
  width: 2.5rem;
  height: 2.5rem;
}
</style>
